var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',{staticClass:"input",attrs:{"controls":false,"min":parseInt(_vm.limit_min),"value":_vm.result},on:{"change":_vm.input,"blur":_vm.listenBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }